import formIdMixin from './formId';
import formInputPropsMixin from './formInputProps';

export default {
  mixins: [formIdMixin, formInputPropsMixin],
};
